<template>
    <div>
        <div v-show="status == 'Saving'">
            <LoadingWheel :width="100" />
        </div>
        <div v-show="status != 'Saving'">
            <ChildrenList :children-ids="children" :view-only="isViewOnly"></ChildrenList>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import type PageDef from "../elements/PageDef";
import type { PageSettings } from "@cs-ts/page-settings";
import { props, Props, components, setup } from "./BaseDefMixin.3";
export default defineComponent({
    props,
    components: {
        LoadingWheel,
        ...components,
    },
    //@ts-ignore
    setup(props: Props<PageDef, PageSettings>) {
        const base = setup<PageDef, PageSettings>(props);

        const status = computed(() => props.data.status);

        return {
            status,
            ...base.expose,
        };
    },
});
</script>
